module.exports = __webpack_public_path__ + "static/img/ent-22.c1b4f32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-22.jpg
// module id = 8Wpl
// module chunks = 52